const becomeMemberBtn = document.querySelector('.become-member');
const myPagesBtn = document.querySelector('.my-pages');

const init = () => {
  document.addEventListener('loggedIn', function () {
    becomeMemberBtn.style.display = 'none';
    myPagesBtn.style.display = 'flex';
  });

  document.addEventListener('notLoggedIn', function () {
    myPagesBtn.style.display = 'none';
    becomeMemberBtn.style.display = 'flex';
  });
};

export default {
  init,
};
